import { withTypography } from 'components/ui';

export const PageHeading = withTypography({
  variant: 'headerTwo',
  textAlign: 'center',
  lineHeight: 32,
});

export const PageSubHeading = withTypography({
  variant: 'headerOne',
  textAlign: 'center',
  lineHeight: 32,
});

export const SectionHeading = withTypography({
  variant: 'headerTwo',
  textAlign: 'center',
  fontSize: '2xl',
  lineHeight: '2xl',
});

export const NeedHelpHeading = withTypography({
  variant: 'headerTwo',
  textAlign: 'center',
  fontSize: 'xl',
  lineHeight: 0,
});
